import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { QueryProvider } from './services/providers/QueryProvider.tsx'
import { initSentry, registerGlobalErrorHandlers } from './lib/sentry'
import { initMixpanel } from './lib/mixpanel'
import { initAppInsights } from './lib/appInsights'
import { logEnvironmentInfo } from './lib/environment'

// Validate required environment variables at startup
const API_URL = import.meta.env.VITE_API_URL;
if (!API_URL) {
  throw new Error('VITE_API_URL is not defined. Check your .env file.');
}
if (import.meta.env.PROD && (API_URL.includes('localhost') || API_URL.includes('127.0.0.1'))) {
  throw new Error('VITE_API_URL is pointing to localhost in a production build. Check your environment configuration.');
}

// Log environment information at startup
logEnvironmentInfo();

// Initialize monitoring before React renders (order matters: Sentry first)
initSentry();
registerGlobalErrorHandlers();
initMixpanel();
initAppInsights();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>,
)
